const Error = () => {



    return (
        <div className="flex justify-center items-center min-h-screen">
            <div className="text-center">
            <h1 className="text-black font-bold text-5xl">404</h1>
            <h1 className="text-black font-bold text-3xl">ERROR PAGINA NO ENCONTRADA</h1>

            <a href="/" className="my-3 font-bold text-primary">
                Volver al inicio
            </a>
            </div>

        </div>
    )
}

export default Error